import BaseModelRequest from '../communicate/BaseModelRequest'

export default class ItemRequest extends BaseModelRequest {
  getModelName () {
    return 'item'
  }

  getItems (data) {
    const url = this.getModelName() + `/load_best_sale?page=${data.page}&limit=${data.limit}`;
    return this.get(url)
  }

  getItemsByCategory (category_id) {
    const url = this.getModelName() + '/category/' + category_id
    return this.get(url)
  }

  getItemDetail (item_id) {
    const url = this.getModelName() + '/detail/' + item_id
    return this.get(url)
  }

  searchItem (data) {
    const url = `search-items?page=${data.page}&limit=${data.limit}`;
    return this.post(url, data)
  }

  filterItems (data) {
    const url = this.getModelName() + '/filters'
    return this.post(url, data)
  }

  addCart () {

  }

  updateCart() {

  }

  promotionInfo(code) {

  }

  addAddress(data) {

  }

  loadAddresses() {

  }

  delAddress() {

  }

  orderItem(data) {

  }

  loadHistoryTransaction() {

  }

  loadCart() {

  }
}



// WEBPACK FOOTER //
// ./src/request/ItemRequest.js